/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The notification types a user cannot switch off in the app. Every member is a type key constant, because
 * the whole class is read as the key list.
 */
export class NotificationMandatoryInAppTypeKeys {
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.ArchiveReady}
     */
    static readonly archive_ready: string = 'archive_ready';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.ArchiveFailed}
     */
    static readonly archive_failed: string = 'archive_failed';
}
